export default class RussianPassport {
  constructor(
    idInDB,
    counterpartyId,
    dayDateDateOfIssue,
    monthDateDateOfIssue,
    yearDateDateOfIssue,
    issuer,
    divisionCode,
    passportSerialNumber,
    passportNumber
  ) {
    this.idInDB = idInDB;
    this.counterpartyId = counterpartyId;
    this.dayDateDateOfIssue = dayDateDateOfIssue;
    this.monthDateDateOfIssue = monthDateDateOfIssue;
    this.yearDateDateOfIssue = yearDateDateOfIssue;
    this.issuer = issuer;
    this.divisionCode = divisionCode;
    this.passportSerialNumber = passportSerialNumber;
    this.passportNumber = passportNumber;
  }

  static createFromData(data) {
    return new RussianPassport(
      data.idInDB,
      data.counterpartyId,
      data.dayDateDateOfIssue,
      data.monthDateDateOfIssue,
      data.yearDateDateOfIssue,
      data.issuer,
      data.divisionCode,
      data.passportSerialNumber,
      data.passportNumber
    );
  }

  static createNew() {
    return new RussianPassport(null, null, null, null, null, null, null, null, null);
  }
}
